import * as React from "react";

function SvgExpandIcon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" {...props}><path d="M2.5 9c.6 0 1 .5 1 1 0 .6-.5 1-1 1s-1-.5-1-1c0-.6.5-1 1-1m0-1.5C1.1 7.5 0 8.6 0 10s1.1 2.5 2.5 2.5S5 11.4 5 10c.1-1.4-1.1-2.5-2.5-2.5zM10 9c.6 0 1 .5 1 1 0 .6-.5 1-1 1-.6 0-1-.5-1-1 0-.6.4-1 1-1m0-1.5c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5-1.1-2.5-2.5-2.5zM17.5 9c.6 0 1 .5 1 1 0 .6-.5 1-1 1-.6 0-1-.5-1-1-.1-.6.4-1 1-1m0-1.5C16.1 7.5 15 8.6 15 10s1.1 2.5 2.5 2.5S20 11.4 20 10s-1.1-2.5-2.5-2.5z" /></svg>;
}

export default SvgExpandIcon;